/**
 * @Description 机会点详情-点位测评概览（所选地址不属于任何开店区域时）
 */

import { FC, useEffect, useState } from 'react';
import styles from './index.module.less';
import cs from 'classnames';
import Evaluations from './components/Evaluations';
import Basic from '@/common/components/business/StoreDetail/components/DynamicDetail/components/AreaOverview/components/Basic';
import V2Title from '@/common/components/Feedback/V2Title';
import { getSiteModelList } from '@/common/api/networkplan';
import { Spin } from 'antd';
import AreaDetailDrawer from '@/views/spotevaluation/pages/index/components/AreaDetailDrawer';
import { isNotEmptyAny } from '@lhb/func';
import { useDispatch } from 'react-redux';
import { changeCurModelId } from '@/views/iterate/store';
import { chancePointEvaluation } from '@/common/api/expandStore/chancepoint';
import { useMethods } from '@lhb/hook';

const SpotEvaluationOverview: FC<any> = ({
  lng,
  lat,
  modelId, // 选址地图模型id
  className = '',
  isDetailPage = false,
}) => {
  const dispatch = useDispatch();

  const [modelList, setModelList] = useState<any[]>([]); // 选址地图模型列表
  const [detail, setDetail] = useState<any>({}); // 详情信息
  const [loading, setLoading] = useState<boolean>(false); // 加载中
  const [drawerData, setDrawerData] = useState<any>({
    open: false,
    cityId: '',
    cityName: '',
    lng: '',
    lat: '',
    poiName: '',
    modelClusterId: '', // 商圈id
    modelConfigId: '', // 商圈模型配置id
    type: '', // 评测类型
    /** 查询类型 */
    poiSearchType: 1,
  });

  // 获取模型列表
  useEffect(() => {
    getSiteModelList().then((val) => {
      setModelList(val);
    });
  }, []);

  useEffect(() => {
    lng && lat && methods.getEvaluationInfo();
  }, [lng, lat]);

  const methods = useMethods({
    getEvaluationInfo() {
      const params = {
        type: 1, // 点位测评类型 默认1 街边店
        lng,
        lat,
        modelConfigId: modelId,
        radius: 500, // 默认500m
      };

      setLoading(true);
      chancePointEvaluation(params).then((res) => {
        setDetail(res);
      }).catch((error) => {
        console.error('Error fetching details:', error);
      }).finally(() => {
        setLoading(false);
      });
    },

    handleClick() {
      if (!isNotEmptyAny(detail)) return;
      // 展示点位测评详情
      let mdlId = null;
      if (modelId) {
        mdlId = modelId; // 使用机会点属性的配置作为选址地图模型id
      } else if (isNotEmptyAny(modelList)) {
        mdlId = modelList[0].id;
      }
      mdlId && dispatch(changeCurModelId(mdlId)); // 使用模型列表的第一个作为选址地图模型id

      const { cityId, cityName, lng, lat, type } = detail;
      setDrawerData({
        open: true,
        cityId,
        cityName,
        lng,
        lat,
        poiName: '',
        modelClusterId: '', // 商圈id
        modelConfigId: mdlId, // 商圈模型配置id
        type, // 评测类型
        radius: 500, // 默认500m
        poiSearchType: 1,
        noDataPermission: true, // 机会点详情的周边信息本品牌门店不受门店数据权限限制
      });
    },
  });

  return (
    <>
      <V2Title
        type='H2'
        divider
        text='周边信息'
        className={cs('pb-16', isDetailPage && 'mt-24')}/>
      <Spin spinning={loading}>
        <div className={cs(styles.basCon, !isDetailPage && 'mb-16', className || '')} onClick={methods.handleClick}>
          <Evaluations detail={detail} />
          <Basic overView={detail} />
        </div>
      </Spin>
      {/* 详情抽屉 */}
      <AreaDetailDrawer
        drawerData={drawerData}
        setDrawerData={setDrawerData}
      />
    </>
  );
};

export default SpotEvaluationOverview;
